import styled, {css} from 'styled-components';

import {colors, inputFieldBase, textEllipsis} from '@app/styles/theme';

export const InputContainer = styled.span`
    position: relative;
    display: block;
    width: 100%;
`;

export const NativeInput = styled.input<{
    hasError?: boolean;
    isValid?: boolean;
    hasAdornment: boolean;
    disabled?: boolean;
    size?: 'sm' | 'md';
}>`
    ${textEllipsis};
    ${(p) =>
        inputFieldBase(
            p.disabled ? 'disabled' : p.hasError ? 'error' : p.isValid ? 'valid' : 'normal',
            p.size,
        )};

    width: 100%;
    padding-right: ${(p) => (p.hasAdornment ? '40px' : '10px')};
    box-sizing: border-box;
    background: ${(p) => (p.disabled ? '#f7f7f7' : '')};
    ${(p) => (p.disabled ? `color: ${colors.darkGrey}` : colors.textSecondary)};

    &::-webkit-input-placeholder {
        color: ${(p) => (p.disabled ? colors.darkGrey : colors.textSecondary)};
    }

    &::-moz-placeholder {
        color: ${(p) => (p.disabled ? colors.darkGrey : colors.textSecondary)};
    }

    &:-ms-input-placeholder {
        color: ${(p) => (p.disabled ? colors.darkGrey : colors.textSecondary)};
    }

    &::-ms-input-placeholder {
        color: ${(p) => (p.disabled ? colors.darkGrey : colors.textSecondary)};
    }

    &::-ms-clear {
        display: none;
    }

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }

    &[type='number'] {
        -moz-appearance: textfield;
    }
`;

export const Adornment = styled.div<{disablePointerEvents?: boolean}>`
    position: absolute;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);

    ${(p) =>
        p.disablePointerEvents &&
        css`
            pointer-events: none;
        `};
`;
